export default __webpack_public_path__ + "static/media/block based group button@2x.730f0e22.png";